import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Button, Stack, Switch, Text } from '@chakra-ui/react';
import { AppDialog } from '@client/components/misc/AppDialog';
import { DialogConfirmFooter } from '@client/components/misc/DialogConfirmFooter';
import { useApiClient } from '@client/hooks/useApiClient';
import { toastError } from '@client/toaster';
import { callApi } from '@client/utils/apiUtils';
import { useState } from 'react';
import { FaPenToSquare } from 'react-icons/fa6';
import { ListingCard } from './ListingCard';
const ListingAvailableDialog = ({ open, title, makeAvailable, pending, onCancel, onConfirm, }) => (_jsx(AppDialog, { title: makeAvailable
        ? `Activate "${title}"?`
        : `Deactivate "${title}"?`, open: open, onCancel: onCancel, pending: pending, size: "sm", titleProps: { truncate: true }, footer: _jsx(DialogConfirmFooter, { onCancel: onCancel, onConfirm: onConfirm, confirmLabel: makeAvailable ? 'Activate' : 'Deactivate', pending: pending }), children: _jsx(Stack, { gap: 2, fontSize: 18, children: makeAvailable ? (_jsx(Text, { children: "This listing will immediately be available for purchase." })) : (_jsxs(_Fragment, { children: [_jsx(Text, { children: "This listing will no longer be available for purchase. It will still be visible to customers." }), _jsx(Text, { children: "To remove this listing entirely, open the \"Edit\" form and click \"Delete Listing\"." })] })) }) }));
export const ListingEditCard = ({ onEdit, ...props }) => {
    const apiClient = useApiClient();
    const [available, setAvailable] = useState(props.available);
    const [pending, setPending] = useState(false);
    const [pendingChecked, setPendingChecked] = useState(null);
    const [switchKey, setSwitchKey] = useState(0);
    const handleToggle = (checked) => {
        setPendingChecked(checked);
    };
    const handleCancel = () => {
        setPendingChecked(null);
        setSwitchKey((k) => k + 1);
    };
    const handleConfirm = async () => {
        if (pendingChecked === null)
            return;
        const checked = pendingChecked;
        setPending(true);
        const result = await callApi(apiClient.shopManager.setListingAvailable({
            params: {
                shopId: props.shopShortId,
                listingShortId: props.shortId,
            },
            body: { available: checked },
        }));
        setPending(false);
        setPendingChecked(null);
        if (result.error !== null) {
            toastError('Failed to update listing. Please try again.');
        }
        else {
            setAvailable(checked);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(ListingCard, { ...props, topRight: _jsxs(Button, { size: "sm", variant: "subtle", borderRadius: "md", onClick: onEdit, fontSize: 20, children: [_jsx(FaPenToSquare, {}), "Edit"] }), topLeft: props.trackInventory &&
                    props.inventory === 0 && (_jsx(Badge, { colorPalette: "red", size: "lg", fontSize: 18, children: "Out of Stock" })), actionMenu: _jsxs(Switch.Root, { checked: available, disabled: pending, onCheckedChange: ({ checked }) => handleToggle(checked), size: "lg", pr: 1, children: [_jsx(Switch.HiddenInput, {}), _jsx(Switch.Control, {})] }, switchKey) }), _jsx(ListingAvailableDialog, { open: pendingChecked === true, title: props.title, makeAvailable: true, pending: pending, onCancel: handleCancel, onConfirm: handleConfirm }), _jsx(ListingAvailableDialog, { open: pendingChecked === false, title: props.title, makeAvailable: false, pending: pending, onCancel: handleCancel, onConfirm: handleConfirm })] }));
};
